<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p *ngIf="!data.show_metadata" [innerHtml]="data.content"></p>
<!--  <app-metadata-results *ngIf="data.show_metadata" style="display: flex; flex-direction: row; align-items: center; flex: 1; margin: 5px 10px 5px 0"-->
<!--                        [display_columns]="['description', 'url']" [feature_class_id]="data.content" [open]="true"></app-metadata-results>-->
</div>
<div mat-dialog-actions style="justify-content: flex-end;">
  <button mat-button (click)="dialogRef.close()">Close</button>
</div>
